import React from 'react';
import { Stack, Typography } from '@mui/material';

import { SpotReportData } from '../../types/spot';

import styles from './CamListItemSpotInfo.module.scss';

interface Props {
  spot: SpotReportData;
}

const CamListItemSpotInfo: React.FC<Props> = ({ spot }) => (
  <div className={styles.camListItemSpotInfoName}>
    <Stack direction="row" alignItems="start">
      <Typography
        className="sl-cam-list-item-spot-info"
        component="p"
        variant="callout1"
        color="text.base"
      >
        {spot.name}
      </Typography>
    </Stack>
  </div>
);

export default CamListItemSpotInfo;
